import React from 'react'
import type { Icon } from 'shared/utils'

const Offers = (props: Icon) => {
    const { color = 'black', size = 24, className = 'offers' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                fillRule="evenodd"
                d="M18.312 7v1.04h-.5V7H6.5v.996H6V7H2.851L2 7.863l1.17 1.185L2 10.222l1.17 1.185L2 12.582l1.17 1.185L2 14.953l1.17 1.174L2.3 17h15.512v-1.04h.5V17h3.389l-.871-.873L22 14.953l-1.17-1.186L22 12.582l-1.17-1.175L22 10.222l-1.17-1.174L22 7.863 21.14 7h-2.828zM6 11.392h.5V9.128H6v2.264zm11.8.043h.5V9.172h-.5v2.263zM6 14.785h.5v-2.262H6v2.263zm11.8.043h.5v-2.263h-.5v2.263zM6 16.956h.5v-1.04H6v1.04z"
            />
        </svg>
    )
}

export { Offers }
